import { getQaAnswerDetail, answerSimilarGroup } from 'api/qa/index.js'
import { qingtingList } from 'api/qa/questions.js'
import { isObject } from 'utils/tool.js'

const store = {
  namespaced: true,
  state: () => ({
    detail: {},
    answerSimilarGroupList: [],
    qingtingList: []
  }),
  getters: {
    question(state) {
      const { question } = state.detail
      return isObject(question) ? question : {}
    },
    authUser(state) {
      const { authUser } = state.detail
      return isObject(authUser) ? authUser : {}
    }
  },
  mutations: {
    setDetail(state, obj) {
      state.detail = obj
    },
    setSimilarGroup(state, list) {
      state.answerSimilarGroupList = list
    },
    setQingsu(state, list) {
      state.qingtingList = list
    }
  },
  actions: {
    fetchQaAnswerDetail({ commit }, params) {
      return getQaAnswerDetail(params).then(res => {
        if (+res.code === 0) {
          commit('setDetail', res.data || {})
        }
        return Promise.resolve(res)
      })
    },
    fetchAnswerSimilarGroup({ commit }, params) {
      return answerSimilarGroup(params)
        .then(res => {
          if (+res.code === 0) {
            commit('setSimilarGroup', res.data)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchQingtingList({ commit }, params) {
      return qingtingList(params)
        .then(res => {
          if (+res.code === 0) {
            commit('setQingsu', res.data)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}

export default {
  store,
  name: 'qaAnswerDetail'
}
